import isNil from 'lodash/isNil'
import React from 'react'
import {Breadcrumb, BreadcrumbItem, Col, Row} from 'reactstrap'
import './styles.css'
import * as Types from './types'

export const BreadcrumbComponent = ({breadcrumbs}: Types.BreadcrumbProps) => <div>
  <Row className="breadcrumb-header">
    <Col sm="12" md="12" className="text-left">
      <span>
        <Breadcrumb className="breadcrumbs">
        {breadcrumbs.map((b: Types.Breadcrumb, index) => (
                    isNil(b.url) ?
            <BreadcrumbItem key={`breadcrumb-${index}`}>
              <span>{b.title}</span>
            </BreadcrumbItem>
          :
            <BreadcrumbItem key={`breadcrumb-${index}`}>
              <a href={b.url}><span>{b.title}</span></a>
            </BreadcrumbItem>
        ))}
        </Breadcrumb>
      </span>
    </Col>
  </Row>
</div>



// WEBPACK FOOTER //
// ./src/components/breadcrumbs/component.tsx